export default __webpack_public_path__ + "static/media/medicenter-dear-patient-icon1.22fc4099.PNG";